import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingGradeHintFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();

  if (currentStep?.id as OnboardingSteps === "publish_feedback") {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.gradeHint}
          defaultOpen={true}
          side="right"
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingGradeHintFlow;